import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconModule } from '../icon/icon.module';

import { Topbar } from './topbar.component';
import { TopbarGlobal } from './topbar-global.component';
import { TopbarNavigation } from './topbar-navigation.component';
import { TopbarItem } from './topbar-item.component';
import { TopbarMenu } from './topbar-menu.component';

@NgModule({
  declarations: [
    Topbar,
    TopbarGlobal,
    TopbarNavigation,
    TopbarItem,
    TopbarMenu,
  ],
  imports: [
    CommonModule,
    IconModule,
  ],
  exports: [
    Topbar,
    TopbarGlobal,
    TopbarNavigation,
    TopbarItem,
    TopbarMenu,
  ]
})
class TopbarModule { }

export {
  TopbarModule,
  Topbar,
  TopbarGlobal,
  TopbarNavigation,
  TopbarItem,
  TopbarMenu,
};
